// extracted by mini-css-extract-plugin
export default {"card":"rectangular-card_card__e6-7o"};